module.exports = __webpack_public_path__ + "img/yjjb.89318545.png";